import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function AppHeader(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            {/* <img src={HeaderImage} alt="App Header"></img> */}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppHeader.propTypes = {
    className: PropTypes.string.isRequired,
}

AppHeader.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledAppHeader = styled(AppHeader)`
    & {
        /* height: 300px; */
        width: 100vw;
        max-width: 100vw;
        min-width: 100vw;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledAppHeader
